import React from "react";

export default function Footer() {
  return (
    <footer className="container mx-auto px-3 mt-2 mb-3 text-gray-800">
      <p className="mt-5">
        Copyright &copy; <b>EduMine</b> Technologies 2021.
      </p>
    </footer>
  );
}
